export default __webpack_public_path__ + "static/media/We Did it.b5be1a39.jpg";